/**
 * Shared ATS pipeline configuration.
 * Used across ApplicationsPage (kanban + strip) and ApplicationDetailPage (badge + selector).
 */
import { UserPlus, Search, ListChecks, Calendar, Award, CheckCircle2, XCircle } from 'lucide-react';

export const PIPELINE_STAGES = [
  {
    key: 'sourced',
    label: 'Sourced',
    icon: UserPlus,
    // strip (large banner) colors
    stripBg: 'bg-slate-600',
    stripText: 'text-white',
    stripCountBg: 'bg-slate-700/60',
    // badge colors
    badge: 'bg-slate-100 text-slate-700 border-slate-200',
    // kanban column accent
    columnAccent: 'border-t-slate-500',
  },
  {
    key: 'screened',
    label: 'Screened',
    icon: Search,
    stripBg: 'bg-blue-500',
    stripText: 'text-white',
    stripCountBg: 'bg-blue-700/50',
    badge: 'bg-blue-100 text-blue-700 border-blue-200',
    columnAccent: 'border-t-blue-500',
  },
  {
    key: 'shortlisted',
    label: 'Shortlisted',
    icon: ListChecks,
    stripBg: 'bg-cyan-500',
    stripText: 'text-white',
    stripCountBg: 'bg-cyan-700/50',
    badge: 'bg-cyan-100 text-cyan-700 border-cyan-200',
    columnAccent: 'border-t-cyan-500',
  },
  {
    key: 'interview',
    label: 'Interview',
    icon: Calendar,
    stripBg: 'bg-orange-500',
    stripText: 'text-white',
    stripCountBg: 'bg-orange-700/50',
    badge: 'bg-orange-100 text-orange-700 border-orange-200',
    columnAccent: 'border-t-orange-500',
  },
  {
    key: 'offered',
    label: 'Offered',
    icon: Award,
    stripBg: 'bg-green-500',
    stripText: 'text-white',
    stripCountBg: 'bg-green-700/50',
    badge: 'bg-green-100 text-green-700 border-green-200',
    columnAccent: 'border-t-green-500',
  },
  {
    key: 'joined',
    label: 'Joined',
    icon: CheckCircle2,
    stripBg: 'bg-emerald-600',
    stripText: 'text-white',
    stripCountBg: 'bg-emerald-800/60',
    badge: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    columnAccent: 'border-t-emerald-600',
  },
];

export const REJECTED_STAGE = {
  key: 'rejected',
  label: 'Rejected',
  icon: XCircle,
  stripBg: 'bg-red-500',
  stripText: 'text-white',
  stripCountBg: 'bg-red-700/50',
  badge: 'bg-red-100 text-red-700 border-red-200',
  columnAccent: 'border-t-red-500',
};

export const ALL_STAGES = [...PIPELINE_STAGES, REJECTED_STAGE];

// Legacy → canonical (mirrors backend STATUS_ALIAS)
export const STATUS_ALIAS = {
  applied: 'sourced',
  screening: 'screened',
  offer: 'offered',
  hired: 'joined',
  demo_lesson: 'interview',
};

export const normalizeStatus = (s) => (s ? STATUS_ALIAS[s] || s : 'sourced');

export const getStageConfig = (status) => {
  const canonical = normalizeStatus(status);
  return ALL_STAGES.find(s => s.key === canonical) || PIPELINE_STAGES[0];
};
